export const FeedSelector = () => {
    return {
        selected: 'all',

        opened: false,

        init () {
        },

        feed() {
          return this.selected;
        },

        toggleOpen() {
            this.opened = !this.opened;
        },


        open() {
            this.opened = true;
        },

        close() {
            this.opened = false;
        },

        isOpen() {
            return this.opened;
        },

        select(index = 'all') {
            this.selected = index;
        },

        isSelected(index = 'all') {
            return this.selected === index;
        }
    }
}
